<template>
    <div>
        <!-- 星期时间段 -->
        <el-table :data="timeData" @current-change="timeCurrentChange" v-loading.body="tableLoading" class="mainTable"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" height="480px" ref="mainTable" @row-click="rowClick">
            <template slot="empty">
            　　<span style="color: #909399;">{{ emptyValue }}</span>
            </template><br>
            <el-table-column label="星期" prop="week" align="center" min-width="30%"></el-table-column>
            <el-table-column label="节次" prop="timeslot" align="center" min-width="50%"></el-table-column>
        </el-table>
        <div style="width:100%;height:20px;">
        </div>
    </div>
</template>
<script>
    import { confirmMsg } from "utils/message";

    export default {
        props:{
            selectedXnxqbm: {
                type: String,
                default () {
                    return null;
                }
            },
            selectedSiteCode: {
                type: String,
                default () {
                    return null;
                }
            }
        },
        data() {
            return {
                getXnxqbm: this.selectedXnxqbm,
                getSiteCode: this.selectedSiteCode,
                comboData: {
                    changeCode: null,
                    major: null,
                    class: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    Xnxqbm: null,
                    Xnxqmc: null,
                    Cdbh: null,
                    Cdmc: null,
                    Cdlx: null,
                    Qyzt: null,
                },
                timeForm: {
                    week: null,
                    timeslot: null,
                },
                xnxqInfo: [], //学年学期下拉框
                cdlxInfo: [], //场地类型下拉框
                weekInfo: [], //星期下拉框
                timeslotInfo: [], //时间段
                tableData: [],
                currentXnxq: null,
                currentPage: 1,
                limit: 10,
                total: null,
                timecurrentPage: 1,
                timelimit: 10,
                timetotal: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                treeVisible: false,
                formSubmiting: false,
                targetTermInfo: [],
                disabled: true,
                checktermResult: null,
                timeData: [],
                timeDialogVisible: false,
                editType: null,
                selectedRow: null,
                oldweek: null,
                oldtimeslot: null,
                emptyValue: "",
                rules: {//表单验证
                    originTerm: [{ required: true, message: "请选择来源学期", trigger: "blur" }],
                    targetTerm: [{ required: true, message: "请选择目标学期", trigger: "blur" }],
                },
                dateTimeRule: {
                    week: [{required: true, message: "请选择日期",trigger: ["blur"],}],
                    timeslot: [{required: true, message: "请选择使用时间", trigger: ["blur"],}],
                },
                defaultProps: {
                  children: 'children',
                  label: 'label'
                },
            };
        },
        created() {
            this.weekInfo = [{"comboValue":"0","comboName":"周日"},{"comboValue":"1","comboName":"周一"},{"comboValue":"2","comboName":"周二"},{"comboValue":"3","comboName":"周三"},{"comboValue":"4","comboName":"周四"},{"comboValue":"5","comboName":"周五"},{"comboValue":"6","comboName":"周六"}];
            this.timeslotOption();
            this.emptyValue = "暂无数据";
        },
        mounted() {
            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;
                this.queryForm.Xnxqbm = this.getXnxqbm;
                this.queryForm.Cdbh = this.getSiteCode;

                this.$api.teachingSiteManage.teachingSiteInfo.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;

                    this.formatTimeData();
                    if(this.getSiteCode!=""){
                        this.emptyValue = "默认节次无限制";
                    }
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            timeslotOption() {
                const paramMap = {
                    'Xnxqbm': this.getXnxqbm,
                }
                this.$api.teachingSiteManage.teachingSiteInfo.timeslotOption({
                    data: paramMap
                }).then(response => {
                    this.timeslotInfo = response.data.data.timeslot;
                    this.queryList();
                }).catch(error => {
                    console.log(error);
                });
            },
            formatTimeData() {
                if(this.tableData != null){
                    this.timeData = [];
                    if(this.tableData[0].kysj != ''){
                        let weektime = this.tableData[0].kysj.split(",");
                        for(let i=0;i<weektime.length;i++){
                            let times = weektime[i].split("@");
                            let week_sp = times[0].split("#");
                            let week_num = "";
                            let week_name = "";
                            for(let j=0;j<week_sp.length;j++){
                                week_num += week_sp[j]+",";
                                week_name += this.weekInfo[week_sp[j]].comboName+",";
                            }
                            if(week_num!='' && week_name!=''){
                                week_num = week_num.substring(0,week_num.length-1);
                                week_name = week_name.substring(0,week_name.length-1);
                            }

                            let timeslot_sp = times[1].split("#");
                            let timeslot_num = "";
                            let timeslot_name = "";
                            for(let j=0;j<timeslot_sp.length;j++){
                                timeslot_num += timeslot_sp[j]+",";
                                timeslot_name += this.timeslotInfo[parseInt(timeslot_sp[j],10)].comboName+",";
                            }
                            if(timeslot_num!='' && timeslot_name!=''){
                                timeslot_num = timeslot_num.substring(0,timeslot_num.length-1);
                                timeslot_name = timeslot_name.substring(0,timeslot_name.length-1);
                            }
                            this.timeData.push({"weekid": week_num,"week": week_name,"timeslot":timeslot_num});
                        }
                    }
                }
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.Xnxqbm = null;
                this.queryForm.Zydm = null;
                this.queryForm.Bjjc = null;
                this.queryForm.Zxqkshzt = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.currentPage = val;
               this.queryList();
            },
            handleSizeChange(val) {
                this.limit = val;
                this.queryList();
            },
            timePageChange(val) {
                this.timecurrentPage = val;
                this.showTimeInfo();
            },
            timeCurrentChange(val) {
               //this.selectRowData = val;
            },
            timeSizeChange(val) {
                this.timelimit = val;
                this.timecurrentPage = 1;
                this.showTimeInfo();
            },
            handleCheck(data,checkData){
                //console.log("checkedKeys:--"+checkData.checkedKeys);//节点id
                //console.log("checkedNodes:--"+checkData.checkedNodes);//节点数组
                this.selectKeys = checkData.checkedKeys;
            },
            rowClick(row) {
                this.selectedRow = row;
            },
            closeDialog() {
                this.dialogVisible = false;
            },
            timeDialogClose(){
                this.timeDialogVisible = false;
                this.selectedRow = null;
                this.timeForm.week = null;
                this.timeForm.timeslot = null;
                this.oldweek = null;
                this.oldtimeslot = null;
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// siteQueryTime.vue?143635a1